var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyBookGraphic(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 223,
    height: 223,
    viewBox: "0 0 223 223",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_270_4229)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.3399 77.0318C53.8547 76.5268 54.7384 74.8858 54.2334 73.3709C53.7285 71.8561 52.0874 70.9725 50.4463 71.4774C48.9315 71.9823 48.0479 73.6234 48.5528 75.1382C49.0577 76.6531 50.6988 77.5367 52.3399 77.0318Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.7784 67.4379C59.7883 67.0592 60.4194 65.9231 60.0407 64.9132C59.662 63.9033 58.5259 63.2721 57.516 63.6508C56.5061 64.0295 55.875 65.1656 56.2537 66.1755C56.5061 67.1854 57.6423 67.8166 58.7784 67.4379Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.646 90.3788C167.54 88.7377 167.666 85.8343 165.898 84.067C164.257 82.2997 161.354 82.1735 159.587 83.8145C157.693 85.4556 157.567 88.359 159.334 90.1263C160.975 91.8936 163.879 92.0199 165.646 90.3788Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.463 99.2243C173.22 98.4669 173.346 97.3308 172.589 96.5733C171.831 95.8159 170.695 95.6897 169.938 96.4471C169.18 97.2045 169.054 98.3406 169.812 99.0981C170.443 99.9817 171.705 99.9817 172.463 99.2243Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5153 174.107C58.2727 173.35 58.3989 172.214 57.6415 171.456C56.8841 170.699 55.748 170.573 54.9906 171.33C54.2332 172.087 54.1069 173.224 54.8643 173.981C55.6218 174.738 56.7579 174.865 57.5153 174.107Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.273 91.4017V95.9382H143.924H139.503L71.689 95.7056C70.4095 95.7056 69.13 95.4729 67.8505 95.124C67.7342 95.124 67.6178 95.0077 67.5015 95.0077C65.8731 94.4261 64.4772 93.7281 63.314 92.5649C62.3835 91.6344 61.6855 90.2385 61.6855 88.959C61.6855 86.5163 63.663 84.6552 66.4547 83.492C67.3852 83.0267 68.5484 82.7941 69.7116 82.6778C70.1769 82.6778 70.6422 82.5614 71.1074 82.5614H135.432C136.13 82.5614 136.712 82.6778 137.293 82.7941C137.759 82.9104 138.224 83.0267 138.689 83.2594C142.062 84.6552 144.273 87.6795 144.273 91.4017Z",
    fill: "#F1F3F9",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.53 103.034V160.147C152.53 164.102 149.39 167.242 145.435 167.242H76.9226C71.2229 167.242 66.8027 164.567 64.0111 162.357C62.7316 161.31 61.9173 159.681 61.9173 158.053C61.9173 157.239 61.9173 156.424 61.9173 155.61C61.9173 154.447 61.9173 153.051 61.9173 151.655C61.9173 145.141 61.9173 136.417 61.801 127.577C61.801 126.298 61.801 125.018 61.801 123.622C61.801 118.969 61.801 114.317 61.6847 109.897C61.6847 108.617 61.6847 107.338 61.6847 105.942C61.6847 97.2177 61.5684 90.7038 61.5684 89.1917C61.5684 91.7507 64.0111 94.0771 67.268 95.0076C67.3843 95.0076 67.5007 95.124 67.617 95.124C68.7802 95.4729 70.176 95.7056 71.4555 95.7056L139.27 96.0545H144.155H145.319C149.39 95.9382 152.53 99.0788 152.53 103.034Z",
    fill: "white",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.531 119.202V121.296C152.415 121.296 152.299 121.296 152.066 121.296H138.108C135.665 121.296 133.571 122.226 132.059 123.739C130.663 125.134 129.616 127.228 129.5 129.438C129.5 129.555 129.5 129.787 129.5 129.904C129.5 134.673 133.339 138.511 138.108 138.511H152.066C152.764 138.511 153.346 138.279 153.578 137.93C153.694 137.813 153.811 137.581 153.811 137.464V120.249C153.811 119.667 153.229 119.318 152.531 119.202Z",
    fill: "white",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.409 134.383C140.853 134.383 142.889 132.347 142.889 129.904C142.889 127.46 140.853 125.424 138.409 125.424C135.966 125.424 133.93 127.46 133.93 129.904C133.93 132.347 135.966 134.383 138.409 134.383Z",
    fill: "#F1F3F9",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.763 134.545C94.685 134.545 96.3112 132.919 96.3112 130.997C96.3112 129.075 94.685 127.449 92.763 127.449C90.8411 127.449 89.2148 129.075 89.2148 130.997C89.2148 132.919 90.8411 134.545 92.763 134.545Z",
    fill: "#AAB2C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.966 134.545C121.888 134.545 123.514 132.919 123.514 130.997C123.514 129.075 121.888 127.449 119.966 127.449C118.044 127.449 116.418 129.075 116.418 130.997C116.418 133.067 118.044 134.545 119.966 134.545Z",
    fill: "#AAB2C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.6254 119.258L84.8203 123.473L85.8739 125.424L93.679 121.21L92.6254 119.258Z",
    fill: "#AAB2C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.485 119.202L118.432 121.154L126.238 125.367L127.291 123.416L119.485 119.202Z",
    fill: "#AAB2C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.366 142.824C108.652 142.824 110.506 141.434 110.506 139.72C110.506 138.005 108.652 136.615 106.366 136.615C104.08 136.615 102.227 138.005 102.227 139.72C102.227 141.434 104.08 142.824 106.366 142.824Z",
    fill: "#AAB2C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.297 53.6489C155.752 51.1171 143.397 51.5222 132.055 54.8641C129.726 55.573 127.194 56.4845 125.371 58.1048C122.535 60.434 121.32 64.5862 122.232 68.1306C123.143 71.6751 126.181 74.612 129.928 75.3209C132.257 75.9285 135.093 75.1183 136.511 73.1942C137.827 71.1688 137.523 68.1306 135.903 66.3078C134.283 64.2823 131.65 63.4722 129.219 63.5734C126.789 63.6747 124.358 64.5862 122.232 65.7001C115.345 69.4472 109.775 76.0298 107.446 83.7264C106.265 87.4654 105.849 91.3956 106.152 95.2616",
    stroke: "#C9D4E2",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.373 51.0158C173.272 52.5348 173.171 53.9526 172.057 54.2564C170.943 54.5602 170.437 53.5475 169.728 52.1297C169.019 50.8132 169.424 49.3954 170.639 49.0916C171.753 48.7878 173.576 49.1929 173.373 51.0158Z",
    fill: "#F1F3F9",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.157 58.3073C172.461 56.4845 172.765 55.4717 171.752 54.9654C170.638 54.459 169.929 55.3705 168.714 56.5857C167.701 57.6997 168.309 59.32 169.321 59.8264C170.537 60.434 171.853 59.8264 172.157 58.3073Z",
    fill: "#F1F3F9",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.575 54.9654C173.473 55.6743 172.967 56.1807 172.258 56.282C171.954 56.282 171.651 56.282 171.245 56.282C169.828 56.0794 168.714 55.168 168.815 54.2565C168.916 53.3451 170.233 52.8387 171.853 53.0413C172.157 53.0413 172.461 53.1425 172.663 53.2438C173.271 53.4464 173.676 54.1553 173.575 54.9654C173.575 54.8642 173.575 54.9654 173.575 54.9654Z",
    fill: "#F1F3F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.575 54.9654C173.473 55.6743 172.967 56.1807 172.258 56.282C171.954 56.282 171.651 56.282 171.245 56.282C169.828 56.0794 168.714 55.168 168.815 54.2565C168.916 53.3451 170.233 52.8387 171.853 53.0413C172.157 53.0413 172.461 53.1425 172.663 53.2438C173.271 53.4464 173.676 54.1553 173.575 54.9654ZM173.575 54.9654C173.575 54.8642 173.575 54.9654 173.575 54.9654Z",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0898 70.2057C62.0898 68.4841 62.0898 66.7625 63.3051 66.2562C64.6216 65.7498 65.3305 66.9651 66.3432 68.6867C67.2547 70.2057 66.8496 71.8261 65.5331 72.3324C64.4191 72.8388 62.0898 72.535 62.0898 70.2057Z",
    fill: "#F1F3F9",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7987 61.699C62.5962 63.8257 62.2924 65.0409 63.6089 65.5473C64.9254 66.0536 65.6343 64.9397 66.9509 63.3193C67.9636 61.9015 67.2547 60.0786 65.9381 59.5723C64.6216 59.0659 63.0013 59.9774 62.7987 61.699Z",
    fill: "#F1F3F9",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.6855 65.7498C61.6855 64.9396 62.2932 64.332 63.0021 64.2307C63.3059 64.1295 63.711 64.1295 64.1161 64.2307C65.7364 64.332 67.1542 65.2434 67.0529 66.2562C66.9516 67.2689 65.6351 67.9778 63.9135 67.7752C63.6097 67.7752 63.3059 67.674 63.0021 67.5727C62.1919 67.4714 61.6855 66.6612 61.6855 65.7498Z",
    fill: "#F1F3F9",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.5723 66.0536C79.2057 66.0536 98.8523 72.2311 99.1561 94.9158",
    stroke: "#C9D4E2",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeDasharray: "4 4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_270_4229",
    x: 0.410156,
    y: 0.00012207,
    width: 222.18,
    height: 222.616,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 24
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.513726 0 0 0 0 0.556863 0 0 0 0 0.619608 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_270_4229"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.384314 0 0 0 0 0.403922 0 0 0 0 0.431373 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_270_4229",
    result: "effect2_dropShadow_270_4229"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_270_4229",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyBookGraphic);
export default __webpack_public_path__ + "static/media/EmptyBookGraphic.be66a9a61091029d9aadaf19448e9d2a.svg";
export { ForwardRef as ReactComponent };